const firebase = require("firebase");
require("firebase/firestore");

const config = {
  apiKey: 'AIzaSyCz6zl0bA2DZDUVD-fP9laNm4Uok7fem1Q',
  authDomain: 'http://ad-ops-50be9.firebaseapp.com/',
  projectId: 'ad-ops-50be9'
}

firebase.initializeApp(config);

// export const ref = firebase.database().ref()
export const firebaseAuth = firebase.auth

export const db = firebase.firestore();



// WEBPACK FOOTER //
// ./src/utils/constants.js